import React from "react";
import { makeStyles, Box } from "@material-ui/core";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";

function RoundedIcon(props) {
  const useStyles = makeStyles(() => ({
    socialIconWrapper: {
      backgroundColor: props.backgroundColor
        ? props.backgroundColor
        : "#ffffff",
      padding: "5px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  }));

  const classes = useStyles();

  return (
    <Box
      align="center"
      className={classes.socialIconWrapper}
      style={
        isWidthUp("lg", props.width)
          ? //  web
            {
              width: 38,
              height: 38,
              borderRadius: 76,
            }
          : {
              width: 35,
              height: 35,
              borderRadius: 70,
            }
      }
    >
      {props.children}
    </Box>
  );
}

export default withWidth()(RoundedIcon);
